import * as types from "./types";

export const clearLoadingStatus = label => {
  return {
    type: types.CLEAR_LOADING_STATUS,
    payload: label,
  };
};
